import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ScrollAnnouncement = () => {
  const [announcement, setAnnouncements] = useState([]);

  const getAllAnnouncements = async () => {
    try {
      const api = process.env.REACT_APP_API
      const url = api + "/viewweb/webannouncement";
      const res = await axios.get(url);
      setAnnouncements(res?.data?.announcement);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getAllAnnouncements();
  }, []);

  return (
    <div className="flex overflow-x-auto whitespace-nowrap space-x-4 p-1 pb-0">
      {announcement?.map((item, index) => (
        (item?.url || item?.pdf) ? <Link
          key={index}
          to={item.url || item.pdf || "#"}
          target="_blank"
          className="inline-block flex-shrink-0 bg-white px-4 py-1 rounded shadow">
          <div>{item.title}</div>
        </Link> :
          <div key={index} className="inline-block flex-shrink-0 bg-white px-4 py-1 rounded shadow cursor-pointer">
            {item.title} </div>
      ))}
    </div>
  );
};

export default ScrollAnnouncement;
